import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { HomePageState, HomepageItems, PermanentBanner } from './types';
import { homepageActions, HomePageActions } from './action';

const defaultBanner = {
    mobileImage: '',
    desktopImage: '',
    targetUrl: '',
    trackingName: '',
    altText: '',
};
const defaultHomePage: HomepageItems = {
    categoriesSlider: [],
    heroBanner: { altText: '', desktopImage: '', mobileImage: '', targetUrl: '', trackingName: '' },
    placingBanners: [],
    portraitBanners: [],
    permanentBanners: [],
    ugcGalleryBanner: defaultBanner,
    referAFriendBanner: defaultBanner,
    secondaryBanner: {
        ctaText: '',
        desktopImage: '',
        trackingName: '',
        targetUrl: '',
        mobileImage: '',
        subtitle: '',
        title: '',
    },
};

const defaultFieldState = {
    isFetching: false,
    didInvalidate: false,
    error: null,
    identifier: '',
    homepageItems: defaultHomePage,
};

export const validPermanentBanners = (banners: Array<PermanentBanner>): Array<PermanentBanner> =>
    banners.filter(banner => banner.targetUrlDesktop && banner.targetUrlMobile && banner.image && banner.trackingName);

const homepageReducer = createReducer<HomePageState, HomePageActions>(defaultFieldState)
    .handleAction(homepageActions.actions.success, (state, action) => {
        const serverItems = action.payload.data.data.home_items;
        const homepageItems = {
            ...serverItems,
            permanentBanners: validPermanentBanners(serverItems.permanentBanners),
        };
        return {
            ...state,
            homepageItems,
        };
    })
    .handleAction(homepageActions.actions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(homepageActions.actions.request, (state, action) => defaultRequestHandler(state, action));

export default homepageReducer;
